<template>
  <div>
    <div :id="id" :style="{height: '280px'}"></div>
  </div>
</template>
<script>
import echarts from 'echarts'
export default {
  props: {
    id: {
      type: String,
      default: () => ''
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    data: {
      handler(newValue) {
        this.drawLine(newValue)
      },
      immediate: false,
    },
  },
  methods: {
    drawLine (data) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById(this.id))
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        color : [ '#3AA0FF', '#36CBCB', '#F2637B', '#FAD337', '#4ECB73', '#975FE4', 'purple' ],
        series: [{
          name: '油站销量比',
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          tooltip: {
            trigger: 'item',
            formatter: '{b}:￥{c}({d}%)'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '14',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: data
        }]
      })
    }
  }
}
</script>
<style scoped lang="less">

</style>